@let orderId = 'order-tickets' | appendTestId: id();
<aw-table
  [id]="orderId"
  [columns]="columns"
  [header]="header"
  rowFlow="nowrap"
  [defaultPageSize]="5"
  [data]="bookings()"
  [expandable]="true"
  [rowKey]="bookingRowKey"
  [expandedRowTemplate]="expandedRow">
  <ng-template #header let-sortBy="sortBy">
    <aw-table-header
      cellName="actions"
      class="w-24 overflow-hidden"
      [attr.data-testid]="orderId | appendTestId: 'header-actions'"
      (onSort)="sortBy($event)">
    </aw-table-header>
    <aw-table-header
      cellName="orderId"
      class="w-96 overflow-hidden"
      [attr.data-testid]="orderId | appendTestId: 'header-ticket-id'"
      (onSort)="sortBy($event)">
      {{ cmsTextProvider.orderOverview.ticketId }}
    </aw-table-header>
    <aw-table-header
      cellName="number"
      class="w-56 overflow-hidden"
      [attr.data-testid]="orderId | appendTestId: 'header-number'"
      (onSort)="sortBy($event)">
      {{ cmsTextProvider.orderOverview.number }}
    </aw-table-header>
    <aw-table-header
      cellName="price"
      class="w-90 overflow-hidden"
      [attr.data-testid]="orderId | appendTestId: 'header-price'"
      (onSort)="sortBy($event)">
      {{ cmsTextProvider.orderOverview.price }} </aw-table-header
    ><aw-table-header
      cellName="date"
      class="w-72 overflow-hidden"
      [attr.data-testid]="orderId | appendTestId: 'header-date'"
      (onSort)="sortBy($event)">
      {{ cmsTextProvider.orderOverview.date }}
    </aw-table-header>
    <aw-table-header
      cellName="name"
      class="w-full overflow-hidden"
      [attr.data-testid]="orderId | appendTestId: 'header-name'"
      (onSort)="sortBy($event)">
      {{ cmsTextProvider.orderOverview.ticketName }}
    </aw-table-header>
    <aw-table-header
      cellName="start"
      class="w-56 overflow-hidden"
      [attr.data-testid]="orderId | appendTestId: 'header-start'"
      (onSort)="sortBy($event)">
      {{ cmsTextProvider.orderOverview.start }}
    </aw-table-header>
    <aw-table-header
      cellName="end"
      class="w-56 overflow-hidden"
      [attr.data-testid]="orderId | appendTestId: 'header-end'"
      (onSort)="sortBy($event)">
      {{ cmsTextProvider.orderOverview.end }}
    </aw-table-header>
    <aw-table-header
      cellName="via"
      class="w-56 overflow-hidden"
      [attr.data-testid]="orderId | appendTestId: 'header-via'"
      (onSort)="sortBy($event)">
      {{ cmsTextProvider.orderOverview.via }}
    </aw-table-header>
    <aw-table-header
      cellName="status"
      class="w-96 overflow-hidden"
      [attr.data-testid]="orderId | appendTestId: 'header-status'"
      (onSort)="sortBy($event)">
      {{ cmsTextProvider.orderOverview.status }}
    </aw-table-header>
  </ng-template>
  <ng-template
    #columns
    let-data="data"
    let-toggleExpanded="toggleExpanded"
    let-isExpanded="isExpanded"
    let-index="index">
    @let ticketId = data.id;
    <aw-table-cell
      cellName="actions"
      [attr.data-testid]="orderId | appendTestId: 'data-actions-' + ticketId">
      <button
        type="button"
        class="material-symbols-rounded cursor-pointer px-2"
        (click)="toggleExpanded(data, index)"
        [attr.aria-label]="
          isExpanded(data, index) ? 'Details einklappen' : 'Details ausklappen'
        ">
        {{ isExpanded(data, index) ? 'keyboard_arrow_up' : 'chevron_forward' }}
      </button>
    </aw-table-cell>
    <aw-table-cell
      cellName="orderId"
      [attr.data-testid]="orderId | appendTestId: 'data-order-id' + ticketId">
      {{ data.id ?? '-' }}
    </aw-table-cell>
    <aw-table-cell
      cellName="number"
      [attr.data-testid]="orderId | appendTestId: 'data-number' + ticketId">
      {{ data.number ?? '-' }}
    </aw-table-cell>
    <aw-table-cell
      cellName="price"
      [attr.data-testid]="orderId | appendTestId: 'data-price' + ticketId">
      {{
        data.productDefinition.price.priceIncludingVat
          | decimalsToCents
          | centsToEuros
      }}
    </aw-table-cell>
    <aw-table-cell
      cellName="date"
      [attr.data-testid]="orderId | appendTestId: 'data-date' + ticketId">
      {{ data.createdAt | date: DATE_FORMAT }},<br />
      {{ data.createdAt | date: TIME_FORMAT }}
    </aw-table-cell>
    <aw-table-cell
      cellName="name"
      [attr.data-testid]="orderId | appendTestId: 'data-name' + ticketId">
      {{ data.name }}
    </aw-table-cell>
    <aw-table-cell
      cellName="start"
      [attr.data-testid]="orderId | appendTestId: 'data-start' + ticketId">
      {{ data.start ?? '-' }}
    </aw-table-cell>
    <aw-table-cell
      cellName="end"
      [attr.data-testid]="orderId | appendTestId: 'data-end' + ticketId">
      {{ data.end ?? '-' }}
    </aw-table-cell>
    <aw-table-cell
      cellName="via"
      [attr.data-testid]="orderId | appendTestId: 'data-via' + ticketId">
      {{ data.via ?? '-' }}
    </aw-table-cell>
    <aw-table-cell
      cellName="status"
      [attr.data-testid]="orderId | appendTestId: 'data-status' + ticketId">
      <aw-order-status-chip
        [id]="'details-' + orderId + '-data-status-ship'"
        [type]="EStatusChipType.dark"
        [orderEvents]="events()"></aw-order-status-chip>
    </aw-table-cell>
  </ng-template>
  <ng-template #expandedRow let-data="data">
    <div
      class="border-standard-outline bg-standard-hover-main/10 w-full rounded-lg border p-4">
      <div
        class="px-4 py-3 text-lg font-semibold"
        [attr.data-testid]="
          orderId | appendTestId: 'details-' + data.id + '-headline'
        ">
        {{ cmsTextProvider.orderOverview.detailsHeadline }}
      </div>

      <div class="flex w-full flex-col px-4 py-2">
        @let rowClass = 'flex flex-row py-2';
        @let cellClass = 'w-1/2';
        @let attributeClass = 'font-semibold';
        @let dividerClass = 'border-b-1';

        <div [ngClass]="[rowClass, dividerClass]">
          <div
            [ngClass]="[cellClass, attributeClass]"
            [attr.data-testid]="
              orderId | appendTestId: 'details-' + data.id + '-ticket-id-label'
            ">
            {{ cmsTextProvider.orderOverview.ticketId }}
          </div>
          <div
            [ngClass]="cellClass"
            [attr.data-testid]="
              orderId | appendTestId: 'details-' + data.id + '-ticket-id'
            ">
            {{ data.id }}
          </div>
        </div>
        <div [ngClass]="[rowClass, dividerClass]">
          <div
            [ngClass]="[cellClass, attributeClass]"
            [attr.data-testid]="
              orderId | appendTestId: 'details-' + data.id + '-type-label'
            ">
            {{ cmsTextProvider.orderOverview.type }}
          </div>
          <div
            [ngClass]="cellClass"
            [attr.data-testid]="
              orderId | appendTestId: 'details-' + data.id + '-type'
            ">
            <!-- @TODO distinguish between Verkauf & Storno -->
            <!-- this will be done once tickets for cancellation handling exist -->
            Verkauf
          </div>
        </div>
        <div [ngClass]="[rowClass, dividerClass]">
          <div
            [ngClass]="[cellClass, attributeClass]"
            [attr.data-testid]="
              orderId | appendTestId: 'details-' + data.id + '-vat-rate-label'
            ">
            {{ cmsTextProvider.orderOverview.vatRate }}
          </div>
          <div
            [ngClass]="cellClass"
            [attr.data-testid]="
              orderId | appendTestId: 'details-' + data.id + '-vat-rate'
            ">
            {{ data.productDefinition.price.vatRate }}
          </div>
        </div>
        <div [ngClass]="[rowClass, dividerClass]">
          <div
            [ngClass]="[cellClass, attributeClass]"
            [attr.data-testid]="
              orderId | appendTestId: 'details-' + data.id + '-order-id-label'
            ">
            {{ cmsTextProvider.orderOverview.orderId }}
          </div>
          <div
            [ngClass]="cellClass"
            [attr.data-testid]="
              orderId | appendTestId: 'details-' + data.id + '-order-id'
            ">
            {{ id() }}
          </div>
        </div>
        <div [ngClass]="[rowClass, dividerClass]">
          <div
            [ngClass]="[cellClass, attributeClass]"
            [attr.data-testid]="
              orderId | appendTestId: 'details-' + data.id + '-number-label'
            ">
            {{ cmsTextProvider.orderOverview.number }}
          </div>
          <div
            [ngClass]="cellClass"
            [attr.data-testid]="
              orderId | appendTestId: 'details-' + data.id + '-number'
            ">
            {{ data.bookingNumber || '-' }}
          </div>
        </div>
        <div [ngClass]="[rowClass, dividerClass]">
          <div
            [ngClass]="[cellClass, attributeClass]"
            [attr.data-testid]="
              orderId | appendTestId: 'details-' + data.id + '-price-label'
            ">
            {{ cmsTextProvider.orderOverview.price }}
          </div>
          <div
            [ngClass]="cellClass"
            [attr.data-testid]="
              orderId | appendTestId: 'details-' + data.id + '-price'
            ">
            {{
              data.productDefinition.price.priceIncludingVat
                | decimalsToCents
                | centsToEuros
            }}
          </div>
        </div>
        <div [ngClass]="[rowClass, dividerClass]">
          <div
            [ngClass]="[cellClass, attributeClass]"
            [attr.data-testid]="
              orderId | appendTestId: 'details-' + data.id + '-storno-label'
            ">
            {{ cmsTextProvider.orderOverview.cancelled }}
          </div>
          <div
            [ngClass]="cellClass"
            [attr.data-testid]="
              orderId | appendTestId: 'details-' + data.id + '-storno'
            ">
            -
          </div>
        </div>
        <div [ngClass]="[rowClass, dividerClass]">
          <div
            [ngClass]="[cellClass, attributeClass]"
            [attr.data-testid]="
              orderId | appendTestId: 'details-' + data.id + '-infos-label'
            ">
            {{ cmsTextProvider.orderOverview.infos }}
          </div>
          <div
            [ngClass]="cellClass"
            [attr.data-testid]="
              orderId | appendTestId: 'details-' + data.id + '-infos'
            ">
            -
          </div>
        </div>
        <div [ngClass]="[rowClass]">
          <div
            [ngClass]="[cellClass, attributeClass]"
            [attr.data-testid]="
              orderId | appendTestId: 'details-' + data.id + '-travellers-label'
            ">
            {{ cmsTextProvider.orderOverview.travellers }}
          </div>
          <div
            [ngClass]="cellClass"
            [attr.data-testid]="
              orderId | appendTestId: 'details-' + data.id + '-travellers'
            ">
            {{ data.productDefinition.numberOfPeople }}
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</aw-table>
